<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (antiScaldValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(antiScaldValveSelection.Name)"
              for="antiScaldValveInput" class="halfWidthInputLabel">Anti-Scald Valve:</label>
              <input type="checkbox" class="checkboxInput" id="antiScaldValveInput"
                #antiScaldValveInput [checked]="'true' === antiScaldValveSelection.Value"
                (change)="selectionChanged(antiScaldValveSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (accessoryPumpControlModuleSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(accessoryPumpControlModuleSelection.Name)"
                for="accessoryPumpControlModuleInput"
              class="halfWidthInputLabel">Accessory Pump Control Module:</label>
              <input type="checkbox" class="checkboxInput" id="accessoryPumpControlModuleInput"
                #accessoryPumpControlModuleInput [checked]="'true' === accessoryPumpControlModuleSelection.Value"
                (change)="selectionChanged(accessoryPumpControlModuleSelection, accessoryPumpControlModuleInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (compressorSoftStartKitSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(compressorSoftStartKitSelection.Name)"
              for="compressorSoftStartKitInput" class="halfWidthInputLabel">Compressor Soft Start Kit:</label>
              <input type="checkbox" class="checkboxInput" id="compressorSoftStartKitInput"
                #compressorSoftStartKitInput [checked]="'true' === compressorSoftStartKitSelection.Value"
                (change)="selectionChanged(compressorSoftStartKitSelection, compressorSoftStartKitInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (smartTankSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">iGate 2 Smart Tank:</label>
              <select class="halfWidthInputField" #smartTankInput
                [class.invalidConfigurationSelection]="isInvalidSelection(smartTankSelection.Name)"
                (change)="selectionChanged(smartTankSelection, smartTankInput.value)"
                [value]="smartTankSelection.Value.toString()">
                @for (allowable of smartTankSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="smartTankSelection.Value && smartTankSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (extendedWarrantySelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(extendedWarrantySelection.Name)"
              for="extendedWarrantyInput" class="halfWidthInputLabel">Extended Warranty:</label>
              <input type="checkbox" class="checkboxInput" id="extendedWarrantyInput"
                #extendedWarrantyInput [checked]="'true' === extendedWarrantySelection.Value"
                (change)="selectionChanged(extendedWarrantySelection, extendedWarrantyInput.checked.toString())">
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
